<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 1
      h1 Transporte

    img.z-2(data-aos="fade-up")(src="@/assets/curso/temas/tema1/1.png", alt="Imagen decorativa")

    .row.justify-content-center.z-2
      .col-lg-10(data-aos="fade-down")
        div.banner-text.bg-color-secundario-s5
          p.mb-0 El transporte constituye un pilar esencial en la dinámica económica y social, ya que posibilita la conexión entre territorios, personas y mercados. Comprender sus fundamentos permite analizar cómo los flujos de bienes y servicios generan valor en la cadena de suministro y contribuyen al logro de objetivos estratégicos en las organizaciones.

    Separador
    #t_1_1(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido.z-2
      h3 1.1 Concepto
    
    .row.justify-content-center.align-items-center
      .col-lg-3
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema1/2.png", alt="Imagen decorativa" data-aos="fade-down-right")
      .col-lg-9
        .row.align-items-center
          .col-lg-2.d-none.d-lg-block
            figure
              img.w-83(src="@/assets/curso/temas/tema1/3.svg", alt="Imagen decorativa" data-aos="fade-down-right")
          .col-lg-10
            p El transporte se entiende como la actividad orientada al traslado de personas, bienes o servicios de un lugar a otro mediante diversos medios. Representa un proceso indispensable en la cadena logística, puesto que genera valor de lugar y de tiempo, al permitir que los productos lleguen desde el punto de producción hasta el lugar de consumo o uso.
        .cajon.color-secundario.p-4
          p.mb-0 El transporte abarca la gestión integral de operaciones, que incluye la planeación, ejecución, control y optimización de flujos materiales e informativos. Su finalidad es alcanzar un equilibrio entre rapidez, costo, confiabilidad, capacidad y seguridad, de manera que se satisfagan las necesidades del cliente y se cumplan los objetivos de la organización en un entorno competitivo y sostenible.

    Separador
    #t_1_2(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido.z-2
      h3 1.2 Tipos y características

    p.mb-4 La elección del tipo de transporte depende de múltiples variables como el tipo de carga, urgencia, destino, infraestructura disponible, costos y sostenibilidad. Esta decisión afecta directamente los indicadores logísticos, como el nivel de servicio, costos operativos, huella de carbono y tiempo de ciclo.

    .p-3.p-md-4.bg-slider.rounded-3
      .tarjeta.tarjeta--blanca.p-4.pt-lg-5
        SlyderA(tipo="b")
          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6
              h5.mb-4 Transporte terrestre
              p.mb-4.mb-lg-0 Traslada personas y mercancías por carreteras o vías férreas, siendo el más utilizado a nivel nacional e intracontinental. El carretero es ideal para entregas puerta a puerta, última milla y cargas perecederas, con alta flexibilidad de rutas y seguimiento en tiempo real. El ferroviario resulta eficiente para cargas masivas como minerales, cereales y químicos, con bajo consumo energético y gran capacidad en trayectos largos.
            .col-sm-8.col-lg-5.col-xl-4
              figure
                img(src='@/assets/curso/temas/tema1/4.png', alt='Imagen ilustrativa')

          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6
              h5.mb-4 Transporte marítimo
              p.mb-4.mb-lg-0 Moviliza mercancías en buques a través de vías acuáticas y es fundamental en el comercio internacional. Se emplea en exportaciones e importaciones de granel, maquinaria, automóviles y contenedores. Se distingue por sus bajos costos unitarios, su eficiencia energética y el soporte que ofrece a las economías de escala.
            .col-sm-8.col-lg-5.col-xl-4
              figure
                img(src='@/assets/curso/temas/tema1/5.png', alt='Imagen ilustrativa')

          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6
              h5.mb-4 Transporte aéreo
              p.mb-4.mb-lg-0 Permite el traslado ágil de personas y mercancías en aeronaves. Es apropiado para productos de alto valor, electrónicos, farmacéuticos, perecederos y atenciones médicas urgentes. Se caracteriza por la reducción significativa de los tiempos de entrega, la mínima manipulación de la carga y la alta trazabilidad.
            .col-sm-8.col-lg-5.col-xl-4
              figure
                img(src='@/assets/curso/temas/tema1/7.png', alt='Imagen ilustrativa')

          .row.align-items-center.justify-content-center
            .col-sm-10.col-lg-7.col-xl-6
              h5.mb-4 Transporte multimodal e intermodal
              p.mb-4.mb-lg-0 Integra de manera secuencial dos o más modos de transporte bajo un esquema logístico. En el multimodal, un solo operador gestiona toda la cadena con un único documento, mientras que el intermodal coordina a varios operadores mediante infraestructura estandarizada como contenedores ISO. Este modelo combina rapidez, eficiencia y cobertura geográfica, optimizando recursos y reduciendo emisiones.
            .col-sm-8.col-lg-5.col-xl-4
              figure
                img(src='@/assets/curso/temas/tema1/8.png', alt='Imagen ilustrativa')

    Separador
    #t_1_3(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido.z-2
      h3 1.3 Normativa y políticas del sector 
       
    .row.justify-content-center.align-items-center.z-2
      .col-lg-7
        p El transporte es una actividad regulada para garantizar seguridad, eficiencia, sostenibilidad y equidad. La normatividad incluye leyes, decretos, resoluciones y reglamentos que definen cómo deben desarrollarse las operaciones. Las políticas corresponden a las estrategias que orientan el desarrollo de la industria, facilitando el cumplimiento de estándares y la adaptación a los cambios del entorno.
        p.mb-4 Estas regulaciones y lineamientos buscan:
      .col-lg-5.d-none.d-lg-block
        figure
          img(src="@/assets/curso/temas/tema1/9.png", alt="Imagen decorativa" data-aos="fade-down-right")

    .fullwidth-bg.fullwidth-bg--1
    .row.justify-content-center.align-items-stretch.mb-4.z-2
      .col-sm-6.col-xl-3.mb-4
        .p-3.bg-color-acento-contenido-ac10.rounded-3.h-100.mb-lg-0
          .row.align-items-center.justify-content-center
            .col-3
              figure
                img(src="@/assets/curso/temas/tema1/10.svg", alt="Imagen decorativa")
            .col-9
              ul.lista-ul--color.mb-0
                li.mb-0 
                  i.fa-solid.fa-circle-check
                  | Asegurar la protección de vidas y bienes.
      .col-sm-6.col-xl-3.mb-4
        .p-3.bg-color-acento-contenido-ac10.rounded-3.h-100.mb-lg-0
          .row.align-items-center.justify-content-center
            .col-3
              figure
                img(src="@/assets/curso/temas/tema1/11.svg", alt="Imagen decorativa")
            .col-9
              ul.lista-ul--color.mb-0
                li.mb-0 
                  i.fa-solid.fa-circle-check
                  | Optimizar la eficiencia operativa.
      .col-sm-6.col-xl-3.mb-4
        .p-3.bg-color-acento-contenido-ac10.rounded-3.h-100.mb-lg-0
          .row.align-items-center.justify-content-center
            .col-3
              figure
                img(src="@/assets/curso/temas/tema1/12.svg", alt="Imagen decorativa")
            .col-9
              ul.lista-ul--color.mb-0
                li.mb-0 
                  i.fa-solid.fa-circle-check
                  | Anticipar riesgos regulatorios.
      .col-sm-6.col-xl-3.mb-4
        .p-3.bg-color-acento-contenido-ac10.rounded-3.px-2.h-100.mb-lg-0
          .row.align-items-center.justify-content-center
            .col-3
              figure
                img(src="@/assets/curso/temas/tema1/13.svg", alt="Imagen decorativa")
            .col-9
              ul.lista-ul--color.mb-0
                li.mb-0 
                  i.fa-solid.fa-circle-check
                  | Promover sostenibilidad y competitividad.

    .row.align-items-center.justify-content-center.z-2
      .col-8.col-sm-6.col-xl-4
        figure
          img.mb-4.mb-xl-0(src='@/assets/curso/temas/tema1/6.png', alt='Imagen ilustrativa' data-aos='fade-down')
      .col-xl-8
        TabsA.color-primario
          .tarjeta.bg-palmera.bg-color-secundario-s5.p-4.pt-5(titulo="Leyes marco")
            h4.mb-4 Leyes marco
            p.mb-5 En Colombia, la Ley 105 de 1993 y la Ley 336 de 1996 establecen los principios generales del servicio público de transporte, definiendo su naturaleza y fundamentos reguladores.

          .tarjeta.bg-palmera.bg-color-secundario-s5.p-4.pt-5(titulo="Decretos reglamentarios")
            h4.mb-4 Decretos reglamentarios
            p.mb-5 El Decreto 1079 de 2015 consolida la normatividad del sector y regula aspectos del transporte terrestre automotor de pasajeros, carga y servicios especiales.

          .tarjeta.bg-palmera.bg-color-secundario-s5.p-4.pt-5(titulo="Resoluciones y circulares")
            h4.mb-4 Resoluciones y circulares
            p.mb-5 Emitidas por el Ministerio de Transporte y la Superintendencia de Transporte, especifican procedimientos técnicos y operativos, requisitos para vehículos, licencias, tarifas y servicios.

          .tarjeta.bg-palmera.bg-color-secundario-s5.p-4.pt-5(titulo="Normativa de seguridad vial")
            h4.mb-4 Normativa de seguridad vial
            p.mb-5 Incluye regulaciones sobre límites de velocidad, uso de cinturón de seguridad, licencias de conducción, mantenimiento de vehículos y el Plan Estratégico de Seguridad Vial (PESV), obligatorio para empresas según la Ley 2251 de 2022 y sus decretos reglamentarios.

          .tarjeta.bg-palmera.bg-color-secundario-s5.p-4.pt-5(titulo="Normativa ambiental")
            h4.mb-4 Normativa ambiental
            p.mb-5 Establece regulaciones sobre emisiones contaminantes, gestión de residuos peligrosos y uso de combustibles limpios, promoviendo el transporte sostenible.

          .tarjeta.bg-palmera.bg-color-secundario-s5.p-4.pt-5(titulo="Convenios internacionales")
            h4.mb-4 Convenios internacionales
            p.mb-5 Incorporan lineamientos de organismos como la ONU e IATA para el transporte de mercancías peligrosas, adoptando prácticas armonizadas a nivel global.

    Separador
    #t_1_4(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido.z-2
      h3 1.4 Objetivos de la organización

    p.mb-4 Los objetivos de la organización del transporte son los resultados deseados que una empresa o entidad busca lograr a través de sus operaciones logísticas y de movilidad. Estos objetivos son fundamentales para guiar las decisiones estratégicas y operativas, garantizando eficiencia y sostenibilidad.  No se limitan solo a mover bienes o personas, sino que abarcan una visión más amplia de valor y desempeño:

    .fullwidth-bg.fullwidth-bg--1
      .row.justify-content-center.align-items-center.factores-slider.z-2.mb-5
        .d-none.d-xl-block.col-xl-4
          figure
            img(src='@/assets/curso/temas/tema1/14.png', alt='Imagen de un mecánico')(data-aos="fade-up")
        .col-xl-8.mb-3.mb-lg-0
          SlyderF(columnas="col-lg-6")
            .tarjeta.tarjeta--blanca.px-4.pt-5.factores-slider__tarjeta
              .row.justify-content-center.mb-3
                .col-5
                  img.factores-slider__icon(src='@/assets/curso/temas/tema1/15.png' alt='Ilustacion de acompañamiento')
              .factores-slider__title-wrapper  
                h4.factores-slider__title.mb-4 Optimización de la eficiencia operativa
              p.mb-4.mb-5.text-center Reducir costos, maximizar la utilización de recursos, optimizar rutas y tiempos, mejorar la productividad.

            .tarjeta.tarjeta--blanca.px-4.pt-5.factores-slider__tarjeta
              .row.justify-content-center.mb-3
                .col-5
                  img.factores-slider__icon(src='@/assets/curso/temas/tema1/16.png' alt='Ilustacion de acompañamiento')
              .factores-slider__title-wrapper  
                h4.factores-slider__title.mb-4 Garantía de la seguridad
              p.mb-4.text-center Reducir la siniestralidad, proteger al personal, salvaguardar la carga, asegurar la seguridad vial.

            .tarjeta.tarjeta--blanca.px-4.pt-5.factores-slider__tarjeta
              .row.justify-content-center.mb-3
                .col-5
                  img.factores-slider__icon(src='@/assets/curso/temas/tema1/17.png' alt='Ilustacion de acompañamiento')
              .factores-slider__title-wrapper  
                h4.factores-slider__title.mb-4 Aseguramiento de la calidad del servicio y satisfacción del cliente
              p.mb-4.text-center Cumplir con los tiempos de entrega o llegada, mantener la integridad de la carga, ofrecer visibilidad y trazabilidad, responder rápidamente a incidentes.

            .tarjeta.tarjeta--blanca.px-4.pt-5.factores-slider__tarjeta
              .row.justify-content-center.mb-3
                .col-5
                  img.factores-slider__icon(src='@/assets/curso/temas/tema1/18.png' alt='Ilustacion de acompañamiento')
              .factores-slider__title-wrapper  
                h4.factores-slider__title.mb-4 Cumplimiento normativo y legal
              p.mb-4.text-center Adherirse a regulaciones, gestionar permisos y licencias.

            .tarjeta.tarjeta--blanca.px-4.pt-5.factores-slider__tarjeta
              .row.justify-content-center.mb-3
                .col-5
                  img.factores-slider__icon(src='@/assets/curso/temas/tema1/19.png' alt='Ilustacion de acompañamiento')
              .factores-slider__title-wrapper  
                h4.factores-slider__title.mb-4 Sostenibilidad y responsabilidad social
              p.mb-4.text-center Reducir el impacto ambiental, fomentar prácticas de transporte sostenible, contribuir al desarrollo económico y social.

            .tarjeta.tarjeta--blanca.px-4.pt-5.factores-slider__tarjeta
              .row.justify-content-center.mb-3
                .col-5
                  img.factores-slider__icon(src='@/assets/curso/temas/tema1/20.png' alt='Ilustacion de acompañamiento')
              .factores-slider__title-wrapper  
                h4.factores-slider__title.mb-4 Adaptabilidad e innovación
              p.mb-4.text-center Integrar nuevas tecnologías, ser flexible ante cambios del mercado, promover la mejora continua.
</template>

<script>
export default {
  name: 'Tema1',
  data: () => ({
    mostrarIndicadorTarjetaAudio: true,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
